/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';
import {
  Dialog,
  Button,
  Typography,
  styled,
} from '@nextiva/next-ui-components';
import { GlobalStoreInterface } from 'interface/globalStore';
import {
  LicensesContext,
  actionTypes,
} from '../../../containers/pages/BillingLicenses/licensesContext/index';

const StyledDialog = styled(Dialog)`
  z-index: 1400;
`;
const StyledDialogContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
const StyledSuccessEmoji = styled('span')`
  font-size: 48px;
  margin-bottom: 24px;
`;
const StyledText = styled(Typography)`
  margin-bottom: 24px;
`;
const StyledContinueButton = styled(Button)`
  margin-top: 40px;
`;
const StyledQuestionsText = styled(Typography)`
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;
const StyledLink = styled('a')`
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
`;
const StyledEmailText = styled(Typography)`
  font-weight: 800;
  margin-bottom: 24px;
`;

const INVOICES_LINK = 'apps/billing/#/landing/invoices';

const onInvoicesLinkClick = (): void => {
  (window as Window).location = `${window.location.origin}/${INVOICES_LINK}`;
};

export const ConfirmationPage = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const { dispatch } = useContext(LicensesContext);

  const onContinueButtonClick = (): void => {
    dispatch({
      type: actionTypes.TOGGLE_PURCHASE_LICENSE_CONFIRMATION_PAGE,
    });
  };

  return (
    <StyledDialog disablePortal disableScrollLock open fullScreen>
      <StyledDialogContentContainer>
        <StyledSuccessEmoji role="img" aria-label="Success Emoji">
          🎉
        </StyledSuccessEmoji>
        <StyledText variant="h5">Thanks for your purchase</StyledText>
        <Typography variant="body2">
          A confirmation email and receipt will been sent to
        </Typography>
        <StyledEmailText variant="body2">
          {globalStoreData?.user?.email ?? ''}.
        </StyledEmailText>
        <StyledQuestionsText variant="subtitle1">
          Let us know if you have{' '}
          <StyledLink
            href="https://www.nextiva.com/support/"
            target="_blank"
            rel="noreferrer"
            data-testid="PlatformAdminUI-PurchaseLicenseModal-ConfirmationPage-QuestionsLink"
          >
            Questions
          </StyledLink>
          ? You can find more
        </StyledQuestionsText>
        <StyledQuestionsText variant="subtitle1">
          information about{' '}
          <StyledLink
            onClick={onInvoicesLinkClick}
            data-testid="PlatformAdminUI-PurchaseLicenseModal-ConfirmationPage-InvoicesLink"
          >
            invoices
          </StyledLink>{' '}
          in billing.
        </StyledQuestionsText>
        <StyledContinueButton
          color="primary"
          variant="contained"
          data-testid="PlatformAdminUI-PurchaseLicenseModal-ConfirmationPage-ContinueButton"
          onClick={onContinueButtonClick}
        >
          Continue
        </StyledContinueButton>
      </StyledDialogContentContainer>
    </StyledDialog>
  );
};
